export default "https://d1e6s5z4lzmgxx.cloudfront.net/3cbd492b-c681-4587-ab2f-cab322978701/images/fortisimo-icon.svg?cd52fbd6408a9f4f0b25374cad804a27";